"use client";

import { c as _c } from "react/compiler-runtime";
import TrackedLink from "../../../_components/global/TrackedLink";
import { inhomzEvents } from "../../../_lib/events";
import ProgressiveImage from "../../../_components/global/ProgressiveImage";
import { useColumnCount } from "../_hooks/useColumnCount";
import { fevicolInhomzRootRoute } from "../../../_constants/tempRootRoute";

// Feed items (`design-idea-galleries/fetch-by-tag`, `/v2/api/media-galleries/
// fetch-exact-galleries`) carry no intrinsic width/height like the static
// CATEGORY_GALLERY_ITEMS pool did, so tiles render at each image's own
// height (see `natural` on ProgressiveImage), laid out row-major across columns.
//
// Reused for two contexts with different above-the-fold positioning:
// `[category]/page.jsx`'s own grid (first tiles ARE the LCP candidate) and
// `[category]/[slug]/_components/DesignIdeaPageLayout.jsx`'s "Similar ideas"
// grid (always below the fold) — callers set `priorityCount` accordingly.
export default function CategoryFeedGrid(t0) {
  const $ = _c(8);
  const {
    items,
    title,
    category,
    priorityCount: t1,
    trackingEvent: t2,
    section: t3
  } = t0;
  const priorityCount = t1 === undefined ? 4 : t1;
  const trackingEvent = t2 === undefined ? inhomzEvents.designCategory.IMAGE_CLICKED : t2;
  const section = t3 === undefined ? "category_feed" : t3;
  const columnCount = useColumnCount();
  let t4;
  if ($[0] !== category || $[1] !== columnCount || $[2] !== items || $[3] !== priorityCount || $[4] !== section || $[5] !== title || $[6] !== trackingEvent) {
    const columns = Array.from({
      length: columnCount
    }, _temp);
    items.forEach((item, index) => columns[index % columnCount].push({
      item,
      index
    }));
    t4 = <div className="flex items-start gap-3">{columns.map((column, columnIndex) => <ul key={columnIndex} className="flex min-w-0 flex-1 flex-col gap-3">{column.map(t5 => {
          const {
            item: item_0,
            index: index_0
          } = t5;
          return <li key={item_0.mediaGalleryId} className="overflow-hidden rounded-[--radius16]"><TrackedLink href={`${fevicolInhomzRootRoute}/design-ideas/${category}/${item_0.mediaGalleryId}`} event={trackingEvent} properties={{
              event_value: item_0.mediaGalleryId,
              category,
              section
            }} prefetch={false} className="relative block w-full"><ProgressiveImage natural={true} src={item_0.mediaUrl} alt={item_0.tags?.[0]?.displayName ? `${item_0.tags[0].displayName} design idea` : `${title} design idea`} className="object-cover" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw" priority={index_0 < priorityCount} /></TrackedLink></li>;
        })}</ul>)}</div>;
    $[0] = category;
    $[1] = columnCount;
    $[2] = items;
    $[3] = priorityCount;
    $[4] = section;
    $[5] = title;
    $[6] = trackingEvent;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp() {
  return [];
}